import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import {
  cashOutPage1,
  dailyCollections,
  dailyCut,
  otherOpCreditChange,
  otherOpCreditDeletion,
  otherOpCreditEditing,
  salesDetails
} from '@/__mocks__/modules/collections/data.ts'

export default [
  {
    method: 'GET',
    path: '/daily/cut?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, dailyCut]
    }
  },
  {
    method: 'GET',
    path: '/report/branch/office/sales?commercialAllyId=3&limit=20',
    reply: async () => {
      await wait()
      return [status.ok, salesDetails]
    }
  },
  {
    method: 'GET',
    path: '/allies/3/sales-details/reportDownload?limit=20',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/report/payment/in/branch/office?commercialAllyId=3&limit=20',
    reply: async () => {
      await wait()
      return [status.ok, dailyCollections]
    }
  },
  {
    method: 'GET',
    path: '/allies/3/daily-collections/reportDownload?limit=20',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/daily/cut/other/operations/credit/change?commercialAllyId=3',
    reply: async () => {
      await wait()
      return [status.ok, otherOpCreditChange]
    }
  },
  {
    method: 'GET',
    path: '/daily/cut/other/operations/credit/editing?commercialAllyId=3',
    reply: async () => {
      await wait()
      return [status.ok, otherOpCreditEditing]
    }
  },
  {
    method: 'GET',
    path: '/daily/cut/other/operations/credit/deletion?commercialAllyId=3',
    reply: async () => {
      await wait()
      return [status.ok, otherOpCreditDeletion]
    }
  },
  {
    method: 'GET',
    path: '/cashout/list/pending?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, cashOutPage1]
    }
  }
]
